var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"full"},[(_vm.list_gridOptions)?_c('vxe-grid',_vm._b({ref:"bIshopgoodsoperate",on:{"toolbar-button-click":_vm.list_toolbarButtonClickEvent}},'vxe-grid',_vm.list_gridOptions,false)):_vm._e(),_c('add-index',{key:_vm.modealKey,ref:"addIndex",attrs:{"row":_vm.row},on:{"submit":_vm.submit}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }